import React, { useCallback } from 'react';
import { Container, Box, Alert, LinearProgress } from '@mui/material';

import pickBy from 'lodash/pickBy';

import { useSyllabus } from '@hooks/useSyllabus';
import Lessons from '@/components/common/Lessons';

const ReadingPassageList: React.FC = React.memo(() => {
    const { isLoading, error, fetchAiLessons } = useSyllabus();

    const handleFetchAILessons = useCallback((filters: any) => {
        fetchAiLessons(pickBy({ skill: 'reading', page: 1, page_size: 9, ...(filters || {}) }));
    }, []);

    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '24px',
                p: '0px !important',
                maxWidth: 'none !important',
            }}
        >
            {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                    {error}
                </Alert>
            )}
            {/* Lessons Grid */}
            <Lessons skill="reading" onFetch={handleFetchAILessons} />
        </Container>
    );
});

ReadingPassageList.displayName = 'ReadingPassageList';

export default ReadingPassageList;
